// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mediaalpha-container{>div:first-of-type{padding:0!important}&.--no-description-toggle{.mav-partner__collapse-toggle{display:none!important}}}", ""]);
// Exports
module.exports = exports;
